/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FacetDto } from '../models/facet-dto';
import { GlobalSearchResultTypeEnum } from '../models/global-search-result-type-enum';

@Injectable({
  providedIn: 'root',
})
export class SuggestService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation suggest
   */
  static readonly SuggestPath = '/suggest/{entity}/{field}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `suggest()` instead.
   *
   * This method doesn't expect any request body.
   */
  suggest$Response(params: {
    entity: GlobalSearchResultTypeEnum;
    field: string;
    search: string;
    limit?: number;
  }): Observable<StrictHttpResponse<Array<FacetDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SuggestService.SuggestPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('field', params.field, {});
      rb.query('search', params.search, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FacetDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `suggest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  suggest(params: {
    entity: GlobalSearchResultTypeEnum;
    field: string;
    search: string;
    limit?: number;
  }): Observable<Array<FacetDto>> {

    return this.suggest$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FacetDto>>) => r.body as Array<FacetDto>)
    );
  }

}
